import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useSeo } from "@/hooks/useSeo";

const LegalPage = ({ title, description, children }) => {
  useSeo(title, description);
  return (
    <div className="min-h-screen islamic-bg">
      <header className="bg-white/80 backdrop-blur-md border-b border-slate-100 sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/"><Logo /></Link>
          <Link to="/" className="flex items-center gap-1 text-sm font-bold text-primary hover:underline">
            <ArrowLeft className="w-4 h-4" /> Accueil
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <h1 className="text-3xl sm:text-4xl font-black text-slate-900 mb-2">{title}</h1>
        <p className="text-sm text-slate-400 mb-8">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>
        <div className="space-y-6 text-slate-600 leading-relaxed [&_h2]:text-xl [&_h2]:font-black [&_h2]:text-slate-800 [&_h2]:mt-6 [&_h2]:mb-2">
          {children}
        </div>
      </main>
    </div>
  );
};

export function Terms() {
  return (
    <LegalPage title="Conditions Générales d'Utilisation" description="Conditions générales d'utilisation de Coach Quran, application d'apprentissage et de mémorisation du Coran.">
      <p>Bienvenue sur Coach Quran. En utilisant notre application, vous acceptez les présentes conditions d'utilisation.</p>
      <h2>1. Objet</h2>
      <p>Coach Quran est une application éducative permettant d'apprendre à lire l'arabe, de mémoriser et de réviser le Coran, avec un suivi de progression pour les élèves, parents et professeurs.</p>
      <h2>2. Compte utilisateur</h2>
      <p>Vous êtes responsable de la confidentialité de vos identifiants et de toute activité effectuée depuis votre compte. Les informations fournies lors de l'inscription doivent être exactes.</p>
      <h2>3. Utilisation acceptable</h2>
      <p>Vous vous engagez à utiliser l'application dans le respect des lois en vigueur et à ne pas porter atteinte au bon fonctionnement du service ni aux droits des autres utilisateurs.</p>
      <h2>4. Contenu coranique</h2>
      <p>Les données coraniques (texte, traduction, audio) proviennent de sources publiques (AlQuran Cloud). Elles sont fournies à des fins éducatives.</p>
      <h2>5. Disponibilité</h2>
      <p>Nous nous efforçons d'assurer la disponibilité du service, sans garantie d'absence d'interruption. Certaines fonctionnalités peuvent évoluer.</p>
      <h2>6. Contact</h2>
      <p>Pour toute question relative à ces conditions, contactez-nous via les canaux indiqués dans l'application.</p>
    </LegalPage>
  );
}

export function Privacy() {
  return (
    <LegalPage title="Politique de Confidentialité" description="Politique de confidentialité de Coach Quran : quelles données nous collectons et comment nous les protégeons.">
      <p>La protection de vos données personnelles est importante pour nous. Cette politique explique quelles informations nous collectons et comment nous les utilisons.</p>
      <h2>1. Données collectées</h2>
      <p>Nous collectons les informations que vous fournissez (prénom, nom, email, rôle, catégorie d'âge) ainsi que vos données d'apprentissage (progression, révisions, récitations, statistiques).</p>
      <h2>2. Utilisation des données</h2>
      <p>Vos données servent à personnaliser votre parcours, suivre votre progression, permettre le suivi par un parent ou professeur, et améliorer le service.</p>
      <h2>3. Partage</h2>
      <p>Nous ne vendons pas vos données. Elles ne sont accessibles qu'à vous-même et, le cas échéant, au professeur ou parent auquel votre compte est rattaché.</p>
      <h2>4. Sécurité</h2>
      <p>Les mots de passe sont chiffrés et les accès sont protégés. Nous appliquons des mesures raisonnables pour protéger vos informations.</p>
      <h2>5. Vos droits</h2>
      <p>Vous pouvez accéder à vos données, les corriger depuis votre profil, ou demander leur suppression.</p>
      <h2>6. Contact</h2>
      <p>Pour toute demande relative à vos données, contactez-nous via l'application.</p>
    </LegalPage>
  );
}
